<template>
  <b-card>
    <template #header>
      <b-row>
        <b-col>
          Stats
        </b-col>
        <b-col>
          <b-button v-if="!isTv" :variant="groupByWeek ? 'success' : 'secondary'" class="btn-sm"
            @click="groupByWeek = !groupByWeek;">Group by week</b-button>
          <b-button v-if="!isTv" class="ml-2 btn-sm" @click="exportToCSV">Export</b-button>
        </b-col>
        <b-col>
          <treeselect v-model="showLabels" :multiple="true" :options="labelOptions" :clearable="true" :searchable="true"
            :close-on-select="true">
          </treeselect>
        </b-col>
        <b-col>
          <treeselect v-model="fieldType" :options="fieldTypeOptions">
          </treeselect>
        </b-col>
      </b-row>
    </template>
    <div v-if="spinners.contentIsLoading" class="text-center">
      <b-spinner type="grow" variant="primary" />
    </div>
    <div v-else>
      <b-table striped hover :items="weekLoad" :fields="fields" sticky-header="600px">
        <template v-slot:cell()="{ field: { key }, value, item }">
          <template v-if="convertableFields.includes(key)">
            {{ fieldValue({ key, item }) }}
          </template><template v-else-if="key == 'billablePercent'">
            {{ value.toFixed(1) }} %
          </template><template v-else>
            {{ value }}
          </template>
        </template>
      </b-table>
      {{ }}
      <!-- <apexchart width="100%" height="100%" type="line" :options="chartOptions" :series="weekLoad"></apexchart> -->
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import * as XLSX from 'xlsx';
import Treeselect from '@riophae/vue-treeselect';
import Services from '@/services';

export default {
  mounted() {
    this.getData();
  },
  props: {
  },
  data() {
    return {
      fieldTypes: ['hours', 'percent', 'finances', 'finances_percent'],
      fieldTypeExt: {
        hours: 'h',
        percent: '%',
        finances: 'EUR',
        finances_percent: '%'
      },
      fieldType: 'hours',
      showLabels: [],
      labels: [],
      cattegories: {
        total: 'total',
        billable_total: 'billable_total',
        billable: 'billable',
        unbillable: 'unbillable',
        sales: 'sales',
        idle: 'idle',
        sick: 'sick',
        vacation: 'vacation',
        internal: 'internal',
        education: 'education',
      },
      spinners: {
        contentIsLoading: true,
      },
      // chartStart: ,
      issues: [],
      project: [],
      issue_labels: [],
      projectByExternalId: {},
      issueLabelsByIssueId: {},
      categoryById: {},
      categoryFilter: {},
      categories: [],
      groupByWeek: true,
    };
  },
  components: {
    Treeselect,
    // apexchart: VueApexCharts,
  },
  computed: {
    ...mapGetters('Auth', ['isTv']),
    labelOptions() {
      return this.labels.map((label) => ({ id: label, label }));
    },
    fieldTypeOptions() {
      return this.fieldTypes.map((label) => ({ id: label, label }));
    },
    chartStart() {
      return this.isTv
        ? moment().startOf('year').add(-1, 'years')
        : moment().startOf('year').add(-3, 'years');
    },

    ganttIssues() {
      const s = moment(this.chartStart);
      return this.issues.filter((i) => s.isBefore(i.date_started_at) && i.date_started_at.isBefore(moment()));
    },
    maxDate() { return moment.max(this.ganttIssues.map((e) => e.date_started_at)); },
    weeks() {
      const s = moment(this.chartStart);
      // do not show future
      const e = moment.min(moment(this.maxDate).startOf('week').add(1, 'weeks'), moment());
      const weeks = [];
      for (let m = s; m.isBefore(e); m.add(1, 'weeks')) {
        weeks.push([moment(m), moment(m).add(1, 'weeks')]); // console.log(m.format('YYYY-MM-DD'));
      }
      return weeks;
    },
    years() {
      const s = moment(this.chartStart);
      // do not show future
      const e = moment.min(moment(this.maxDate).startOf('year').add(1, 'year'), moment());
      // console.log(s.format(),e.format());
      const years = [];
      for (let m = s; m.isBefore(e); m.add(1, 'year')) {
        years.push([moment(m), moment(m).add(1, 'year')]); // console.log(m.format('YYYY-MM-DD'));
      }
      return years;
    },
    months() {
      const s = moment(this.chartStart);
      // do not show future
      const e = moment.min(moment(this.maxDate).startOf('month').add(1, 'month'), moment());
      const months = [];
      for (let m = s; m.isBefore(e); m.add(1, 'month')) {
        months.push([moment(m), moment(m).add(1, 'month')]); // console.log(m.format('YYYY-MM-DD'));
      }
      return months;
    },
    // yLabels() { return Array.from(this.groupByWeek ? Array(52).keys() : Array(12).keys()).map((i) => String((i % 52) + 1).padStart(2, '0')); },
    fields() {
      return [
        { key: 'date', label: 'date', class: 'text-right' },
        { key: 'nr', label: '#', class: 'text-right' },
        { key: 'billablePercent', label: 'Billable', class: 'text-right' },
        ...[
          ...Object.keys(this.cattegories),
          ...this.showLabels.map((l) => `l_${l}`)
        ].map((l) => ({
          key: l,
          label: l,
          class: 'text-right'
        }))
      ];
    },

    convertableFields() {
      return [
        ...Object.keys(this.cattegories),
        ...this.showLabels.map((l) => `l_${l}`),
      ];
    },

    exportData() {
      return this.weekLoad.map((item) => ({
        ...this.fields.map(({ key }) => {
          if (this.convertableFields.includes(key)) {
            return { [`${key} ${this.fieldTypeExt[this.fieldType]}`]: this.fieldValue({ key: key, item }, true) };
          } if (key === 'billablePercent') {
            return { [`${key} %`]: item[key] };
          } if (key === 'date') {
            return { [`${key}`]: moment(item[key], 'DD/MM/YYYY').toDate() };
          }
          return { [key]: item[key] };
        }).reduce((i, f) => ({ ...i, ...f }), {})
      }));
    },

    weekLoad() {
      const groupBy = this.groupByWeek ? this.weeks : this.months;
      const totalLoad = groupBy.map(([w, w2]) => {
        // const w2 = moment(w).add(7, 'days');
        const statsSum = this.ganttIssues.reduce((stats, i) => {
          if (!(i.date_started_at.isAfter(w) && i.date_started_at.isBefore(w2))) return stats; // issue worklog out of this week
          const loggedHours = i.actuals_time || 0;
          const actuals = i.actuals || 0;
          (i.categories || []).forEach((c) => {
            stats.actuals_time[c] = (stats.actuals_time[c] || 0) + loggedHours;
            stats.actuals[c] = (stats.actuals[c] || 0) + actuals;
          });
          this.issueLabels(i.issue_id).forEach((l) => {
            stats.actuals_time[`l_${l}`] = (stats.actuals_time[`l_${l}`] || 0) + loggedHours;
            stats.actuals[`l_${l}`] = (stats.actuals[`l_${l}`] || 0) + actuals;
          });

          return stats;
        }, { actuals: {}, actuals_time: {} });

        // pretify stats
        [
          ...Object.keys(this.cattegories),
          ...this.labels.map((l) => `l_${l}`)
        ].forEach((c) => {
          if (!statsSum.actuals_time[c]) statsSum.actuals_time[c] = 0;
          statsSum.actuals_time[c] = Math.round(statsSum.actuals_time[c] * 10) / 10;
          if (!statsSum.actuals[c]) statsSum.actuals[c] = 0;
          statsSum.actuals[c] = Math.round(statsSum.actuals[c] * 10) / 10;
        });

        return {
          // x: w.valueOf(),
          nr: this.groupByWeek ? w.week() : (w.month() + 1),
          date: w.format('DD/MM/YYYY'),
          ...statsSum,
          billablePercent: Math.round((statsSum.actuals_time.billable * 1000.0) / statsSum.actuals_time.billable_total) / 10,
        };
      });

      return totalLoad;
    },

  },
  watch: {
  },
  methods: {
    fieldValue({ key, item }, forExport = false) {
      let value = 0;
      if (this.fieldType === 'hours') {
        value = item.actuals_time[key];
      } if (this.fieldType === 'percent') {
        value = (item.actuals_time[key] / item.actuals_time.total) * (forExport ? 1.0 : 100);
      } if (this.fieldType === 'finances') {
        value = item.actuals[key];
      } if (this.fieldType === 'finances_percent') {
        value = (item.actuals[key] / item.actuals.total) * (forExport ? 1.0 : 100);
      }

      if (forExport) return value;
      value = value.toFixed(this.fieldType === 'finances' ? 0 : 1);
      return `${value} ${this.fieldTypeExt[this.fieldType]}`;
    },
    issueLabels(id) {
      return this.issueLabelsByIssueId[id] || [];
    },
    isLabelSelected(label) {
      return this.showLabels.includes(label);
    },
    issueLabelsSelected(id) {
      return this.issueLabels(id).filter(this.isLabelSelected);
    },
    exportToCSV() {
      const ws = XLSX.utils.json_to_sheet(this.exportData);
      const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
      XLSX.writeFileXLSX(wb, 'BillableStats.xlsx', { cellDates: true });
      // const data = new Blob([excelBuffer], { type: fileType });
      // FileSaver.saveAs(data, fileName + fileExtension);
    },
    issueData(i /* issue */) {
      const timeInHours = i.actuals_time / 3600;
      const result = {
        date_started_at: moment(i.date_started_at),
        actuals_time: timeInHours, // convertTohours
        actuals: i.actuals ? Number(i.actuals) : null,
        issue_id: i.issue_id
      };

      const categories = ['total'];
      const project = this.projectByExternalId[i.external_id] || null;
      const projectKey = project?.key;
      const categoryKey = this.categoryById[project?.category_id]?.name;

      if (!['APP'].includes(projectKey)) {
        // Issue is used in billable calculation, so mark it for billable total category
        categories.push('billable_total');
        if (!['Absences', 'INT', 'INT ', 'Pipeline'].includes(categoryKey)) {
          // Issue is billable if not in unbillable project
          categories.push('billable');
        } else {
          categories.push('unbillable');
        }
      }
      if (['PPP'].includes(projectKey)) {
        categories.push('sales');
      }
      if (['AID'].includes(projectKey)) {
        categories.push('idle');
      }
      if (['APSL'].includes(projectKey)) {
        categories.push('sick');
      }
      if (['APV'].includes(projectKey)) {
        categories.push('vacation');
      }
      if (['AP'].includes(projectKey)) {
        categories.push('internal');
      }
      if (['APE'].includes(projectKey)) {
        categories.push('education');
      }

      // result.projectKey = projectKey;
      // result.categoryKey = categoryKey;
      result.categories = categories;
      return result;
    },
    getData() {
      // Services.dash.allProjectDayLogs({ from_date: this.chartStart.format('YYYY-MM-DD') }).then(({ data }) => {
      Services.dash.allProjectDayLogsWithIssues({ from_date: this.chartStart.format('YYYY-MM-DD') }).then(({ data }) => {
        // console.log(data);
        this.categories = data.categories;
        this.issue_labels = data.issue_labels;
        this.labels = data.labels;
        this.categoryFilter = data.projects.reduce((cats, p) => { cats[p.category_id] = true; return cats; }, {});
        this.projectByExternalId = data.projects.reduce((projects, p) => ({ ...projects, [p.external_id]: p }), {});
        this.categoryById = this.categories.reduce((categories, c) => ({ ...categories, [c.id]: c }), {});

        this.issueLabelsByIssueId = this.issue_labels.reduce((issueLabels, c) => ({
          ...issueLabels,
          [c.id]: [c.label, ...(issueLabels[c.id] || [])],
        }), {});
        // console.log(this.issueLabelsByIssueId);
        this.issues = data.actuals.map((i) => {
          return {
            // ...i,
            // project: data.projects.find((p) => p.external_id === i.external_id),
            ...(this.issueData(i)),
          };
        });
        // console.log(this.issues);
        // // this.project = data;
        // // this.project.issues = null;
        this.spinners.contentIsLoading = false;
      });
    }
  }
};
</script>

<style>
ul.toolul.tooltipgantt {
  list-style-type: none;
  padding: 1em;
  margin: 0;
}

.chart-body {
  height: 615px;
}
